// 处理添加行的方法
export function handleAddRow (row, numName, valueName, index) {
  row[valueName].splice(index + 1, 0, { id: index + 1, key: '', value: '' })
  row[numName] += 1
  return row
}

/**
 * 递归移除对象/数组中所有层级的 id 字段 (原地修改)
 * @param {Object|Array} data - 要处理的数据
 * @returns {void} 直接修改原始对象
 */
export function removeIds (data) {
  // 处理数组：遍历每个元素递归处理
  if (Array.isArray(data)) {
    data.forEach(item => removeIds(item))
    return
  }

  // 处理对象
  if (data && typeof data === 'object') {
    // 删除当前对象的 id 属性
    if ('id' in data) {
      delete data.id
    }

    // 递归处理所有属性值
    Object.values(data).forEach(value => {
      if (value && typeof value === 'object') {
        removeIds(value)
      }
    })
  }
  return data
}

/**
 * 根据字典类型和值获取字典标签
 *
 * @param {string} dictType 字典类型
 * @param {any} value 值
 * @returns {string|any} 返回字典标签或值
 */
export function getDictLabel (selectDictionary, dictType, value) {
  if (!selectDictionary || !dictType || value === undefined || value === null) {
    return value
  }

  const dictItems = selectDictionary.filter(item => item.dictCode === dictType)
  if (!dictItems || dictItems.length === 0) {
    return value
  }

  const dictItem = dictItems.find(item => String(item.value) === String(value))
  return dictItem ? dictItem.label : value
}

/**
 * 根据字典类型获取字典标签键值对
 *
 * @param {string} dictType 字典类型
 * @returns {string|any} 返回字典标签键值对
 */
export function getDictList (selectDictionary, dictType) {
  if (!selectDictionary || !dictType ) {
    return null
  }

  const dictItems = selectDictionary.filter(item => item.dictCode === dictType)
  if (!dictItems || dictItems.length === 0) {
    return null
  }

  const dictItem = dictItems.map(({ label, value }) => ({ label, value}))
  return dictItem
}
/**
 * 将状态更新到指定数组中
 *
 * @param {Array} originalArray - 原始数组，包含需要更新状态的项
 * @param {Array} updateArray - 包含状态更新信息的数组
 * @returns {Array} - 更新后的数组，包含每个项的状态更新
 */
export function addStatusToItems (originalArray, updateArray) {
  // 创建映射以便快速查找状态更新
  const updateMap = new Map()
  updateArray.forEach(item => {
    updateMap.set(item.id, item.status)
  })

  // 遍历原始数组并添加status属性
  return originalArray.map(item => {
    // 检查当前项是否需要更新
    if (updateMap.has(item.id)) {
      // 创建新对象以保持不可变性（避免修改原对象）
      return {
        ...item,
        status: updateMap.get(item.id)
      }
    }
    // 不需要更新的项直接返回
    return item
  })
}
/**
 * 合并设备名称函数
 *
 * @param devices 设备数组
 * @param dictItems 字典项数组
 * @returns 返回带有设备名称的设备数组
 */
export function mergeDeviceNames (devices, dictItems) {
  // 创建字典映射：value -> sysDictItemName
  const dictMap = {}
  dictItems.forEach(item => {
    dictMap[item.value] = item.sysDictItemName
  })

  // 遍历设备数组，添加deviceName属性
  return devices.map(device => {
    // 将serialType转换为字符串（因为字典中的value是字符串）
    const typeKey = String(device.serialType)
    return {
      ...device,
      deviceName: dictMap[typeKey] || null // 找不到匹配项时设为null
    }
  })
}
